import React, { useEffect, useState } from 'react';
import { useGetPreferencesQuery, useUpdatePreferencesMutation } from '../../../../store/services/student/PreferenceService';
import { showSuccessToast } from '../../PluginsMenu/Toastr/Toastr';

export const NotificationPreferences = () => {
    const { data, isLoading, isSuccess, refetch } = useGetPreferencesQuery();
    const [updatePreferences] = useUpdatePreferencesMutation();
    const [preferences, setPreferences] = useState([]);

    // Initialize preferences when API call succeeds
    useEffect(() => {
        if (isSuccess && data?.data?.preferences) {
            // Ensure In-App notifications are always enabled and not editable
            const processedPreferences = data.data?.preferences.map(pref => 
                pref.name === 'In-App' 
                    ? { ...pref, isSelected: true, isDisabled: true }
                    : pref
            );
            setPreferences(processedPreferences);
        }
    }, [isSuccess, data]);

    const handleChange = (e, id) => {
        const { checked } = e.target;
        setPreferences((prev) =>
            prev.map((pref) =>
                pref.id === id && !pref.isDisabled ? { ...pref, isSelected: checked } : pref
            )
        );
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Always include In-App notifications (id: 1) regardless of user selection
        const inAppPreference = preferences.find(pref => pref.name === 'In-App');
        const otherSelectedIds = preferences
            .filter(pref => pref.isSelected && pref.name !== 'In-App')
            .map(pref => pref.id);
        
        // Combine In-App ID with other selected preferences
        const selectedIds = inAppPreference ? [inAppPreference.id, ...otherSelectedIds] : otherSelectedIds;
    
        const response = await updatePreferences({preferences: selectedIds});
        if(response.data.succeeded) {
            showSuccessToast("Notification Preferences Updated Successfully");
            await refetch();
        }
    };

    if (isLoading) return <p>Loading preferences...</p>;

    return (
        <div className="card profile-card card-bx ">
            <div className="card-header">
                <h6 className="title">Notifications Preferences</h6>
            </div>
            <form onSubmit={handleSubmit}>
                <div className="card-body">
                    <p>Select how you would like to receive notifications:</p>
                    {preferences.map((pref) => (
                        <div className="form-check" key={pref.id}>
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id={`pref-${pref.id}`}
                                checked={pref.isSelected}
                                onChange={(e) => handleChange(e, pref.id)}
                                disabled={pref.isDisabled}
                            />
                            <label 
                                className={`form-check-label ${pref.isDisabled ? 'text-muted' : ''}`} 
                                htmlFor={`pref-${pref.id}`}
                            >
                                {pref.name} Notifications
                                {pref.isDisabled && (
                                    <small className="text-muted ms-2">(Required)</small>
                                )}
                            </label>
                        </div>
                    ))}
                    <div className="mt-3">
                        <small className="text-muted">
                            <strong>Note:</strong> In-App notifications are required and cannot be disabled.
                        </small>
                    </div>
                </div>
                <div className="card-footer align-items-center d-flex">
                    <button className="btn btn-primary" type="submit">
                        SAVE PREFERENCES
                    </button>
                </div>
            </form>
        </div>
    );
};